import React from 'react';
import '../styles/ClimbingToken.css';

const ClimbingToken = () => {
  return <h1 className="climbing-title">🏔️ Climbing Page</h1>;
};

export default ClimbingToken;